// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6d8c7ef2","453":"9c922e49","455":"4e47bb34","977":"51155aa4"}[chunkId] + ".chunk.js";
};